const TrendDown = () => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <g id='TrendDown'>
                <path
                    id='Vector'
                    d='M16.3125 14.0625L9.5625 7.3125L6.75 10.125L1.6875 5.0625'
                    stroke='#7ABA8A'
                    strokeWidth='1.125'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    id='Vector_2'
                    d='M16.3125 9.5625V14.0625H11.8125'
                    stroke='#7ABA8A'
                    strokeWidth='1.125'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
        </svg>
    );
};

export default TrendDown;
